import React from 'react';
import noOrderIcon from '../../../../../../assets/svg/openPackage.svg';

const NoSMS = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={noOrderIcon} alt="سفارشی یافت نشد." height={60} width={60} />
      <div>
        این کاربر هنوز بارگیری جدیدی ندارد. از دکمه افزودن بارگیری می توانید
        استفاده کنید.
      </div>
    </div>
  );
};

export default React.memo(NoSMS);
